<div style="display:flex; min-width:186px; align-items: center;">
  @if (currentUser) {
    <div style="flex: 1; padding-top: 12px; text-align: center">
      @if (currentUser) {
        <app-avatar [id]="currentUser.id" [mat-menu-trigger-for]="userMenu"></app-avatar>
        <span data-logged-in-user style="display:none">{{currentUser.name}}</span>
        <span data-current-team-id style="display:none">{{currentUser.current_team_id}}</span>
      }
    </div>
  }
  @if (currentUser?.currentTeam) {
    <div style="flex: 3; align-items: center; text-align:center">
      @if (currentUser && currentUser?.activePositions.length > 0) {
        <button mat-raised-button class="button-user" color=""
          [mat-menu-trigger-for]="userMenu">
          <span data-current-team-name>{{currentTeamName}}</span>
        </button>
      }
    </div>
  }
</div>
<mat-menu #userMenu="matMenu">
  @if (showDashboard()) {
    <a mat-menu-item [routerLink]="[dashboardPath()]"  [disabled]="onDashboard()">Go to Dashboard</a>
    <a mat-menu-item [routerLink]="[dashboardPath()]" [queryParams]="{edit: true}" [disabled]="!onDashboard()">Edit Dashboard</a>
    <mat-divider></mat-divider>
  }
  @for (position of activePositions; track $index) {
    <div>
      @if (position.teamId === currentUser.current_team_id && position.roleId === currentUser.currentRoleId) {
        <div style="display:flex">
            <div style="flex: 1">
                <button mat-menu-item class="selectedTeamMenuItem" disabled="true">
                    <span>{{position.team?.name}} ({{position.role?.name}})</span>
                  </button>
            </div>
            <div style="flex: 0 0 32px">
                <mat-icon style="color:green">check</mat-icon>
            </div>
        </div>
      } @else {
        <button mat-menu-item (click)="selectCurrentTeam(position)">
            {{position.team?.name}} ({{position.role?.name}})
        </button>
      }
    </div>
  }
  <mat-divider></mat-divider>
  <a mat-menu-item [routerLink]="[profilePath]">My Profile</a>
  @if(currentUserSvc.hasUber()) {
    <button mat-menu-item (click)="impersonate()">Impersonate</button>
  }
  <mat-divider></mat-divider>
  <button mat-menu-item (click)="logoutCurrentUser()">Logout</button>
  <p style="margin-left:15px; font-size: small; opacity: 50%">
     Build: {{buildVersion}}: {{buildDate}}
  </p>  
</mat-menu>

